<template>
	<div class="index">
		<div class="top">
			<div class="index_left">
				<div class="left_top">
					<div class="left_topLeft">
						<div style="
                border-bottom: 1px solid #ccc;
                padding: 20px;
                background: rgba(255, 255, 255, 0.945);
                font-weight: bold;
                font-size: 15px;
                box-sizing: border-box;
              ">
							我的余额
						</div>
						<div style="
                background: white;
                padding: 20px;
                text-align: center;
                box-sizing: border-box;
              ">
							<p>账户可用余额（元）</p>
							<p style="font-size: 25px; color: #3470ff">{{price}}</p>
						</div>
					</div>
					<div class="left_topRight">
						<div style="
                border-bottom: 1px solid #ccc;
                padding: 20px;
                background: rgba(255, 255, 255, 0.945);
                font-weight: bold;
                font-size: 15px;
                box-sizing: border-box;
              ">
							在线缴费
						</div>
						<div class="index_menu" style="background: white; padding: 10px; box-sizing: border-box">
							<router-link :to="{ path: '/renTal',query:{
								time:updateTime
							} }">
								<div style="box-sizing: border-box; padding: 12px">
									<p>欠缴缴费</p>
									<p style="font-size: 25px">{{amountpaid}}</p>
								</div>
							</router-link>

							<!-- <div style="box-sizing: border-box; padding: 12px">
                <p>合同缴费</p>
                <p style="font-size: 25px">{{num1}}</p>
              </div>
              <div style="box-sizing: border-box; padding: 12px">
                <p>按账期缴费</p>
                <p style="font-size: 25px">{{num2}}</p>
              </div> -->
						</div>
					</div>
				</div>
				<div class="left_bottom">
					<div style="
              border-bottom: 1px solid #ccc;
              padding: 20px;
              font-weight: bold;
              font-size: 15px;
              box-sizing: border-box;
            ">
						缴费类型
					</div>
					<div class="left_bottom_menu">
						<router-link :to="{ path: '/renTal',query:{itemCode:'1001',itemName:'租赁缴费'}}">
							<div class="div" style="
			         box-sizing: border-box;
			         padding: 12px;
			         text-align: center;
			       ">
								<div class="img" style="
			           width: 50px;
			           height: 50px;
			   
			           border-radius: 10px;
			           margin: 0 auto;
			         ">
									<img style="width: 100%; color: tomato" src="../assets/img/租赁缴费.png" alt="" />
								</div>
								<p style="font-size: 13px; margin-top: 10px">租赁缴费</p>
							</div>
						</router-link>
						<router-link :to="{ path: '/renTal',query:{itemCode:'1004',itemName:'物业缴费'}}">
							<div class="div" style="
                  box-sizing: border-box;
                  padding: 12px;
                  text-align: center;
                ">
								<div class="img" style="
                    width: 50px;
                    height: 50px;

                    border-radius: 10px;
                    margin: 0 auto;
                  ">
									<img style="width: 100%; color: tomato" src="../assets/img/物业缴费.png" alt="" />
								</div>
								<p style="font-size: 13px; margin-top: 10px">物业缴费</p>
							</div>
						</router-link>
						<router-link :to="{ path: '/renTal' ,query:{itemCode:'1101,1102',itemName:'水电缴费'}}">
							<div class="div" style="
                  box-sizing: border-box;
                  padding: 12px;
                  text-align: center;
                ">
								<div class="img" style="
                    width: 50px;
                    height: 50px;

                    border-radius: 10px;
                    margin: 0 auto;
                  ">
									<img style="width: 100%" src="../assets/img/水电缴费.png" alt="" />
								</div>
								<p style="font-size: 13px; margin-top: 10px">水电缴费</p>
							</div>
						</router-link>
						<!-- <router-link :to="{ path: '/renTal' }">
              <div
                class="div"
                style="
                  box-sizing: border-box;
                  padding: 12px;
                  text-align: center;
                "
              >
                <div
                  class="img"
                  style="
                    width: 50px;
                    height: 50px;

                    border-radius: 10px;
                    margin: 0 auto;
                  "
                >
                  <img
                    style="width: 100%"
                    src="../assets/img/预交费.png"
                    alt=""
                  />
                </div>
                <p style="font-size: 13px; margin-top: 10px">预缴费</p>
              </div>
            </router-link> -->
						<router-link :to="{ path: '/renTal' }">
							<div class="div" style="
                  box-sizing: border-box;
                  padding: 12px;
                  text-align: center;
                ">
								<div class="img" style="
                    width: 50px;
                    height: 50px;

                    border-radius: 10px;
                    margin: 0 auto;
                  ">
									<img style="width: 100%; color: tomato" src="../assets/img/全账单缴费.png" alt="" />
								</div>
								<p style="font-size: 13px; margin-top: 10px">全账单缴费</p>
							</div>
						</router-link>
						<router-link :to="{ path: '/renTal',query:{itemCode:'7001',itemName:'定金缴费'} }">
							<div class="div" style="
                  box-sizing: border-box;
                  padding: 12px;
                  text-align: center;
                ">
								<div class="img" style="
                    width: 50px;
                    height: 50px;

                    border-radius: 10px;
                    margin: 0 auto;
                  ">
									<img style="width: 100%; color: tomato" src="../assets/img/订金缴费.png" alt="" />
								</div>
								<p style="font-size: 13px; margin-top: 10px">定金缴费</p>
							</div>
						</router-link>
					</div>
				</div>
			</div>
			<div class="index_right">
				<div style="
            border-bottom: 1px solid #ccc;
            padding: 20px;
            box-sizing: border-box;
            display: flex;
            justify-content: space-between;
          ">
					<p style="font-size: 15px; font-weight: bold">账户信息</p>
					<a style="color: #5085ff; cursor: pointer" @click="$router.push({path:'/MyHome'})">查看更多</a>
				</div>
				<div style="display: flex; padding: 20px; box-sizing: border-box">
					<img src="" alt="" />
					<p style="font-size: 15px">{{tabledata.corporationName}}</p>
				</div>
				<div class="index_right_bottom">
					<div>
						<p>首次开通时间：<span>&nbsp;{{tabledata.createTime}}</span></p>
						<div style="display: flex;">
							<div>在租铺位信息:</div>

							<div style="width:60%;display: flex;flex-flow: wrap;
                  -webkit-line-clamp:3;
                  -webkit-box-orient: vertical;
                  display: -webkit-box;
                  text-overflow: ellipsis;overflow: hidden;cursor: pointer;">
								&nbsp;
								<span v-for="item in shopName"><span
										:title="shopName">{{item+'、'| ellipsis}}</span></span>
							</div>

						</div>
						<div style="display: flex;">
							<div style="">多经铺位信息:</div>
							<div style="width:60% ;overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap;cursor: pointer;">
								&nbsp;
								<!-- 	&nbsp;&nbsp; -->
								<span v-for="item in shopNames" :title="shopNames" v-if="link">{{item| ellipsis}}</span>
								<span v-for="item in shopNames" :title="shopNames"
									v-if="lonk">{{item+'、'| ellipsis}}</span>
							</div>
						</div>
						<p>合同数（份）：<span>{{tabledata.contractCount}}</span></p>
					</div>
				</div>
			</div>
		</div>
		<div class="bottom">
			<div style="
          border-bottom: 1px solid #ccc;
          padding: 20px;
          box-sizing: border-box;
          display: flex;
          justify-content: space-between;
        ">
				<p style="font-size: 15px; font-weight: bold">平台公告</p>
				<a @click="$router.push({path: '/UserAnnouncement'})" style="color: #5085ff; cursor: pointer">查看更多</a>
			</div>
			<div class="ul">
				<ul v-for="item,index in list" :key='item.index'>
					<router-link :to="{path:'/AnnouncementDetail',query: {id:item.id}}">
						<li>
							<div class="p">
								<p style="
                   width: 20px;
                    height: 20px;
                    line-height: 20px;
                    background: #eff4ff;
                    color: #3873ff;
                    text-align: center;
                ">
									{{index+1}}
								</p>
								<p style="
                  overflow: hidden;
                  width: 85%;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                ">
									<span v-if='item.label==""'> </span>
									<span v-else>【{{item.label}}】</span>
									<!-- 【{{item.label}}】 -->
									{{item.noticeTitle | ellipsis}}
								</p>
							</div>

							<p>{{item.releaseTime}}</p>
						</li>
					</router-link>
				</ul>
			</div>
		</div>
	</div>
</template>
<script>
	import API from "@/api/pay";
	import Until from '../../../utils/utils'
	export default {
		name: "index",
		data() {
			return {
				lonk: true,
				link: false,
				amountpaid: 0,
				price: 0,
				tabledata: [],
				staticId: 0,
				dialogVisible: false,
				gettime: "",
				shopVo: {},
				list: [],
				lists: [],
				//在租铺位
				shopName: [],
				//多经铺位
				shopNames: [],
				updateTime: '',
				gettimes: ''
			};
		},
		filters: {
			//超过20位显示 ...
			ellipsis: function(value) {
				if (!value) return "";
				if (value.length > 60) {
					return value.slice(0, 60) + "......";
				}
				return value;
			}
		},
		mounted() {
			
			var _this = this;
			console.log(_this.updateTime)
			_this.gettimes = new Date().getTime()
			console.log(_this.gettimes);
			// debugger
		},
		created() {
			this.getlist()
			this.getUserList();
			this.getbalance()
			this.amountobepaid()
		},
		methods: {
			//   skip(a){

			//     this.$router.push(a)
			//   },
			addDate() {
				var _this = this;
				var d = new Date();
				var ye = d.getFullYear();
				var mo = (d.getMonth() + 1).toString().padStart(2, "0");
				var da = d.getDate().toString().padStart(2, "0");
				var updateTime = ye + "-" + mo + "-" + da;
				_this.updateTime = updateTime;
				console.log(updateTime);
			},
			//获取欠缴金额
			amountobepaid() {
				this.addDate()
				let updateTime = this.updateTime
				let phone = Until.getSession("shopVo");
				let params = {
					businessId: phone,
					paymentDueBeginDate: "",
					paymentDueEndDate: updateTime,
					paidStatus: 0,
				};
				API.paygetTotalUnpaidAmount(params).then((res) => {
					if (res.data.code == 200) {
						console.log("获取合同列表", res);
						if (res.data.data == null) {
							this.amountpaid = 0
						} else {
							this.amountpaid = res.data.data;
						}

					}
				});
			},
			//获取余额
			getbalance() {
				let phone = Until.getSession("shopVo");
				let params = {
					businessId: phone
				}
				API.selectPreReceiptTotalByBusinessId(params).then((res) => {
					console.log(res)
					if (res.data.code == 200) {
						if (res.data.data == null) {
							this.price = 0
						} else {
							this.price = res.data.data
						}
					}
				})
			},
			//获取公告
			getlist() {
				let phone = Until.getSession("shopVo");
				let params = {
					pageNum: this.pageNum,
					pageSize: this.pageSize,
					businessId: phone
				}
				API.announCement(params).then((res) => {
					console.log(res)
					for (var i in res.data.data.list) {
						console.log(new Date(res.data.data.list[i].releaseTime).getTime() - this.gettimes <= 0)
						if (new Date(res.data.data.list[i].releaseTime).getTime() - this.gettimes <= 0) {
							this.list.push(res.data.data.list[i])
							this.total = res.data.data.total
						}
					}
					// this.total=res.data.data.total
				})
			},
			//获取商户信息
			getUserList() {
				// console.log(localStorage.getItem(token))
				let lesseeId = Until.getSession("pay").shopVo.shopId;
				let mallCode = Until.getSession("pay").shopVo.mallCode;
				let params = {
					lesseeId: lesseeId,
					mallCode: mallCode
				};
				console.log(params)
				// debugger
				API.lesseedetail(params).then((res) => {
					if (res.data.code == 200) {
						this.tabledata = res.data.data
						this.lists = res.data.data.investContractList
						console.log('合同', this.lists)
						for (var i in this.lists) {
							if (this.lists[i].contractBoothType == 1 && this.lists[i].shopName !== null) {
								if (this.shopName.indexOf(this.lists[i].shopName) === -1) {
									this.shopName.push(this.lists[i].shopName)
									console.log(this.shopName)
								}
							} else if (this.lists[i].contractBoothType == 2 && this.lists[i].shopName !== null) {
								if (this.shopNames.indexOf(this.lists[i].shopName) === -1) {
									console.log(this.lists[i].shopName)
									this.shopNames.push(this.lists[i].shopName)
									if (this.shopNames.length == 1) {
										this.link = true
										this.lonk = false
									} else {
										this.link = false,
										this.lonk = true
									}
								}

							}
						}
						console.log(this.shopNames[0])
						console.log(this.shopName)
					}
				}).catch((err) => {
					console.log(err)
				});
			},
		},
	};
</script>
<style scoped>
	.index {
		font-family: "微软雅黑";
		box-sizing: border-box;
		padding: 20px;
		/*  background-color: #f2f2f2; */
	}

	.top {
		display: flex;
		justify-content: space-between;
	}

	.index_left {
		width: 68%;
	}

	.index_right {
		box-shadow: 2px 2px 10px #909090;
		width: 30%;
		background: rgba(255, 255, 255, 0.945);
	}

	.left_top {
		display: flex;
		justify-content: space-between;
	}

	.left_topLeft {
		box-shadow: 2px 2px 10px #909090;
		width: 49%;
	}

	.left_topRight {
		width: 49%;
		box-shadow: 2px 2px 10px #909090;
	}

	.index_menu {
		display: flex;
		justify-content: space-around;
	}

	.index_menu div {
		/* width: 95px; */
		height: 72px;
	}

	.index_menu div:hover p:nth-child(2) {
		cursor: pointer;
		color: #ed6f18;
	}

	.index_menu div:hover {
		background: #f3f7ff;
	}

	.left_bottom {
		box-shadow: 2px 2px 10px #909090;
		margin-top: 15px;
		background: rgba(255, 255, 255, 0.945);
	}

	.left_bottom_menu {
		display: flex;
		justify-content: space-around;
		padding: 5px;
		box-sizing: border-box;
	}

	.index_right_bottom {
		padding: 20px;
		box-sizing: border-box;
		line-height: 2em;
	}

	.bottom {
		box-shadow: 2px 2px 10px #909090;
		margin-top: 15px;
		background: rgba(255, 255, 255, 0.945);
	}

	.ul {
		padding: 20px;
		box-sizing: border-box;
	}

	.ul li {
		display: flex;
		justify-content: space-between;
		margin-top: 10px;
	}

	.p {
		display: flex;
		width: 80%;
		font-size: 14x;
	}

	.p p:nth-child(2) {
		margin-left: 15px;
	}

	.p p:nth-child(2):hover {
		cursor: pointer;
		color: #5789ff;
	}

	/* .ul li:hover p:nth-child(2) {
  color: rgba(78, 170, 245, 0.945);
} */
	.div:hover {
		cursor: pointer;
		background-color: #f3f7ff;
	}

	.div {
		width: 90px;
		height: 100px;
	}
</style>
